/* eslint-disable */

class Perspectives {
  constructor(settings, attributes) {
    this.settings = settings;
    this.attributes = attributes;

    this.controls = {
      forward: document.querySelector('.video-forward'),
      rewind: document.querySelector('.video-rewind'),
    };

    this.intro = document.querySelector('.lot-selector .video-intro');
    this.perspectiveLabel = document.querySelector('.current-perspective-label');
    this.perspectiveIndicatorImage = document.querySelector('.lot-selector-perspective-indicator-image svg');
    this.areas = Array.from(document.querySelectorAll('.lot-selector-area'));
    this.videos = this.getVideos();

    this.current = this.videos[0];
    if (attributes.perspective) {
      const match = this.videos.find(v => v.label === attributes.perspective);
      if (match) this.current = match;
    }
  }

  init() {
    if (!this.videos.length) return;

    this.preloadVideos();

    if (this.intro) {
      this.intro.addEventListener('ended', () => {
        this.intro.style.transition = 'opacity 2s';
        this.intro.style.opacity = 0;
        setTimeout(() => this.intro.style.display = 'none', 2000);
      });
    }

    if (this.isLastPerspective()) {
      const prevIndex = this.current.index - 1;
      const prev = this.videos[prevIndex >= 0 ? prevIndex : 0];

      this.showPerspective(prev).then(() => {
        prev.forward.style.display = 'none';
        prev.backward.style.display = '';
      });
    } else {
      this.showPerspective(this.current);
    }

    this.hideAreas();
    this.updateView();

    if (this.controls.forward) {
      this.controls.forward.addEventListener('click', () => {
        this.hideAreas();
        this.toggleControlVisibility();
        this.playNext().then(() => this.updateView());
      });
    }

    if (this.controls.rewind) {
      this.controls.rewind.addEventListener('click', () => {
        this.hideAreas();
        this.toggleControlVisibility();
        this.playPrevious().then(() => this.updateView());
      });
    }
  }

  getVideos() {
    const elements = document.querySelectorAll('.lot-selector-video-perspective');
    return Array.from(elements).map((el, index) => ({
      index,
      label: el.dataset.perspective,
      slug: el.dataset.slug,
      forward: el.querySelector('.video-perspective-forward'),
      backward: el.querySelector('.video-perspective-backward'),
      element: el
    }));
  }

  playNext() {
    const nextIndex = this.current.index + 1;
    if (nextIndex >= this.videos.length) return Promise.resolve();

    const from = this.current;
    const to = this.videos[nextIndex];

    from.forward.style.display = '';
    from.backward.style.display = 'none';
    from.forward.play();

    const container = document.querySelector('.lot-selector-video-perspectives');
    if (container) container.classList.add('playing');

    return new Promise(resolve => {
      const onEnd = () => {
        from.forward.removeEventListener('ended', onEnd);

        this.hidePerspective(from);

        this.showPerspective(to).then(() => {
          this.resetPerspective(to);
          this.resetPerspective(from);
          to.forward.style.display = '';
          to.backward.style.display = 'none';
          to.forward.pause();
          to.forward.currentTime = 0;

          this.setCurrent(to);

          if (container) container.classList.remove('playing');
          resolve(this.current);
        });
      };
      from.forward.addEventListener('ended', onEnd);
    });
  }

  playPrevious() {
    const prevIndex = this.current.index - 1;
    if (prevIndex < 0) return Promise.resolve();

    const from = this.current;
    const to = this.videos[prevIndex];

    from.backward.style.display = '';
    from.forward.style.display = 'none';
    from.backward.play();

    const container = document.querySelector('.lot-selector-video-perspectives');
    if (container) container.classList.add('playing');

    return new Promise(resolve => {
      const onEnd = () => {
        from.backward.removeEventListener('ended', onEnd);

        this.hidePerspective(from);

        this.showPerspective(to).then(() => {
          this.resetPerspective(from);
          this.resetPerspective(to);
          to.forward.style.display = '';
          to.forward.pause();
          to.forward.currentTime = 0;
          to.backward.style.display = 'none';

          this.setCurrent(to);

          if (container) container.classList.remove('playing');
          resolve(this.current);
        });
      };
      from.backward.addEventListener('ended', onEnd);
    });
  }

  hidePerspective(perspective) {
    perspective.element.style.display = 'none';
  }

  showPerspective(perspective) {
    return new Promise(resolve => {
      perspective.element.style.display = '';
      setTimeout(resolve, 350);
    });
  }

  resetPerspective(perspective) {
    if (perspective.forward) {
      perspective.forward.pause();
      perspective.forward.currentTime = 0;
    }
    if (perspective.backward) {
      perspective.backward.pause();
      perspective.backward.currentTime = 0;
    }
  }

  setCurrent(perspective) {
    this.current = perspective;
    return this.current;
  }

  hideAreas() {
    this.areas.forEach(area => area.style.display = 'none');
  }

  showVisibleAreas() {
    const visible = this.areas.filter(el => {
      const coords = JSON.parse(el.dataset.coordinates || '{}');
      return coords[this.current.slug];
    });

    this.positionAreas(visible);
    visible.forEach(el => el.style.display = '');
  }

  positionAreas(areas) {
    areas.forEach(el => {
      const coords = JSON.parse(el.dataset.coordinates)[this.current.slug];
      if (el.nodeName.toLowerCase() === 'path') {
        el.setAttribute('d', coords);
      } else if (el.nodeName.toLowerCase() === 'polygon') {
        el.setAttribute('points', coords);
      } else {
        el.style.left = coords.left;
        el.style.top = coords.top;
      }
    });
  }

  toggleControlVisibility() {
    if (this.settings.plan_video_loop && JSON.parse(this.settings.plan_video_loop)) return;

    if (this.controls.forward) {
      this.controls.forward.disabled = this.current.index + 1 === this.videos.length;
    }
    if (this.controls.rewind) {
      this.controls.rewind.disabled = this.current.index === 0;
    }
  }

  updatePerspectiveIndicator() {
    if (this.settings.show_perspective_indicator && JSON.parse(this.settings.show_perspective_indicator)) {
      if (this.perspectiveLabel) {
        this.perspectiveLabel.textContent = this.current.label;
      }
    }

    if (this.perspectiveIndicatorImage) {
      const current = this.perspectiveIndicatorImage.querySelector('.current-perspective');
      if (current) current.classList.remove('current-perspective');

      const newIndicator = this.perspectiveIndicatorImage.querySelector(`[data-perspective="${this.current.slug}"]`);
      if (newIndicator) newIndicator.classList.add('current-perspective');
    }
  }

  updateView() {
    this.showVisibleAreas();
    this.toggleControlVisibility();
    this.updatePerspectiveIndicator();
  }

  isLastPerspective(perspective = this.current) {
    if (this.settings.plan_video_loop && JSON.parse(this.settings.plan_video_loop)) {
      return false;
    }
    return perspective.index === this.videos.length - 1;
  }

  preloadVideos() {
    this.videos.forEach(video => {
      if (window.innerWidth > this.settings.breakpoint) {
        video.forward.setAttribute('preload', '');
        video.backward.setAttribute('preload', '');
      }
    });

    if (this.intro && window.innerWidth > this.settings.breakpoint) {
      this.intro.setAttribute('preload', '');
      this.intro.setAttribute('autoplay', '');
    }
  }
}

// Usage
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > settings.breakpoint) {
    new Perspectives(settings, attributes).init();
  }
});
